import {http} from '@/utils/http'
import {IFilter} from "@/types/main";
import {cleanParams} from "@/utils/cleanParams";

export const chatService = {
    getPersonalChats(filter: IFilter) {
        return http.get('/chats/personal', {
            params: cleanParams(filter)
        })
    },

    getGroupChats(filter: IFilter) {
        return http.get('/chats/groups', {
            params: cleanParams(filter)
        })
    },

    getChatMessages(id: string) {
        return http.get(`/chats/${id}`)
    },
}